module.exports = __webpack_public_path__ + "img/MovingGuidelines.04f6eee7.png";